import { render, staticRenderFns } from "./Catalogs.vue?vue&type=template&id=5a4ca079&scoped=true"
import script from "./Catalogs.vue?vue&type=script&lang=ts"
export * from "./Catalogs.vue?vue&type=script&lang=ts"
import style0 from "./Catalogs.vue?vue&type=style&index=0&id=5a4ca079&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4ca079",
  null
  
)

export default component.exports